import {
	GetZendeskArticleAttachmentsDTO,
	GetZendeskArticleDTO,
	GetZendeskArticlesDTO,
	GetZendeskCategoriesDTO,
	GetZendeskPostDTO,
	GetZendeskSectionsDTO,
	SearchZendeskArticlesDTO,
} from '../types/solution-center';

const ZENDESK_URL = process.env.REACT_APP_ZENDESK_API_HOST
	? process.env.REACT_APP_ZENDESK_API_HOST
	: 'https://inxpo.zendesk.com';

export function GetZendeskArticle(articleId: number): Promise<GetZendeskArticleDTO> {
	return fetch(`${ZENDESK_URL}/api/v2/help_center/en-us/articles/${articleId}`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to get Zendesk article');
		} else {
			throw new Error('Request failed');
		}
	});
}

export function GetZendeskArticleAttachments(
	articleId: number,
): Promise<GetZendeskArticleAttachmentsDTO> {
	return fetch(`${ZENDESK_URL}/api/v2/help_center/en-us/articles/${articleId}/attachments`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to get Zendesk article attachments');
		} else {
			throw new Error('Request failed');
		}
	});
}

export function GetZendeskPost(postId: number): Promise<GetZendeskPostDTO> {
	return fetch(`${ZENDESK_URL}/api/v2/community/posts/${postId}`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to get Zendesk post');
		} else {
			throw new Error('Request failed');
		}
	});
}

export function GetZendeskCategories(): Promise<GetZendeskCategoriesDTO> {
	return fetch(`${ZENDESK_URL}/api/v2/help_center/en-us/categories`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to get Zendesk categories');
		} else {
			throw new Error('Request failed');
		}
	});
}

export function GetZendeskSectionsByCategoryId(categoryId: number): Promise<GetZendeskSectionsDTO> {
	return fetch(`${ZENDESK_URL}/api/v2/help_center/en-us/categories/${categoryId}/sections`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to get Zendesk sections');
		} else {
			throw new Error('Request failed');
		}
	});
}

export function GetZendeskArticlesBySectionId(
	sectionId: number,
	perPage: number = 100,
	page: number = 1,
): Promise<GetZendeskArticlesDTO> {
	const queryParams = `?per_page=${perPage}&page=${page}`;
	return fetch(`${ZENDESK_URL}/api/v2/help_center/en-us/sections/${sectionId}/articles${queryParams}`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to get Zendesk articles');
		} else {
			throw new Error('Request failed');
		}
	});
}

export function SearchZendeskArticles(
	searchQuery: string,
	categoryId: number | null,
): Promise<SearchZendeskArticlesDTO> {
	const queryParams = `?query=${searchQuery}${categoryId ? `&category=${categoryId}` : ''}`;
	return fetch(`${ZENDESK_URL}/api/v2/help_center/articles/search${queryParams}`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Unable to search Zendesk articles');
		} else {
			throw new Error('Request failed');
		}
	});
}
